module.exports = __webpack_public_path__ + "static/media/curate.1c579a85.png";